<div class="error-text">{{errorsService.getError(errorName)?.errorDescription}}</div>
